/**
 * Cliente de autenticación.
 *
 * Única puerta de la SPA hacia Better Auth. Igual que en la API, el resto del
 * código no lo importa directamente: usa los hooks de `lib/session.ts`. Así,
 * cambiar de librería de auth toca dos archivos y no toda la interfaz.
 */

import { organizationClient, twoFactorClient } from 'better-auth/client/plugins';
import { createAuthClient } from 'better-auth/react';

const API_ORIGIN = import.meta.env.VITE_API_ORIGIN ?? 'http://localhost:3000';

export const authClient = createAuthClient({
  baseURL: `${API_ORIGIN}/api/auth`,
  // La sesión viaja en cookie HttpOnly: el JavaScript nunca ve el token, así
  // que un XSS no puede robarlo. A cambio, cada petición debe enviar
  // credenciales explícitamente.
  fetchOptions: {
    credentials: 'include',
  },
  plugins: [organizationClient(), twoFactorClient()],
});

export const { signIn, signUp, signOut, useSession, organization } = authClient;
